import {
  UPC_SCAN_SAVE_REQUEST,
  UPC_SCAN_SAVE_SUCCESS,
  UPC_SCAN_SAVE_FAIL,

  UPC_SCAN_EXPORT_REQUEST,
  UPC_SCAN_EXPORT_SUCCESS,
  UPC_SCAN_EXPORT_FAIL,


  MY_UPC_SLIPS_REQUEST,
  MY_UPC_SLIPS_SUCCESS,
  MY_UPC_SLIPS_FAIL,


  EXPORT_UPC_EXCEL_REQUEST,
  EXPORT_UPC_EXCEL_SUCCESS,
  EXPORT_UPC_EXCEL_FAIL,



  CREATE_MAPPING_REQUEST,
  CREATE_MAPPING_SUCCESS,
  CREATE_MAPPING_FAIL,

  ALL_MAPPINGS_REQUEST,
  ALL_MAPPINGS_SUCCESS,
  ALL_MAPPINGS_FAIL,

  UPDATE_MAPPING_REQUEST,
  UPDATE_MAPPING_SUCCESS,
  UPDATE_MAPPING_FAIL,

  DELETE_MAPPING_REQUEST,
  DELETE_MAPPING_SUCCESS,
  DELETE_MAPPING_FAIL,

  CLEAR_ERRORS
} from "../constants/upcScanConstants";
import api from "../../api";



export const saveUpcScanAction = (productData) => async (dispatch) => {
  try {
    dispatch({ type: UPC_SCAN_SAVE_REQUEST });

    const { data } = await api.post(
      "/api/v1/upc-scan/save",
      productData,
      { headers: { "Content-Type": "application/json" } }
    );

    dispatch({
      type: UPC_SCAN_SAVE_SUCCESS,
      payload: data.message
    });

  } catch (error) {
    dispatch({
      type: UPC_SCAN_SAVE_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

export const exportUpcScanExcelAction = (productData) => async (dispatch) => {
  try {
    dispatch({ type: UPC_SCAN_EXPORT_REQUEST });

    const response = await api.post(
      "/api/v1/upc-scan/export",
      productData,
      { responseType: "blob" }
    );

    const blob = new Blob([response.data]);
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "upc-scan.xlsx";
    link.click();

    dispatch({ type: UPC_SCAN_EXPORT_SUCCESS });

  } catch (error) {
    dispatch({
      type: UPC_SCAN_EXPORT_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};




export const getMyUpcSlips = (page = 1, queryParams = {}) => async (dispatch) => {
  try {
    dispatch({ type: MY_UPC_SLIPS_REQUEST });

    const { data } = await api.get(
      `/api/v1/upc/my-slips?page=${page}&${new URLSearchParams(queryParams).toString()}`
    );

    dispatch({
      type: MY_UPC_SLIPS_SUCCESS,
      payload: data
    });

  } catch (error) {
    dispatch({
      type: MY_UPC_SLIPS_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

export const clearErrors = () => ({ type: CLEAR_ERRORS });




export const exportUpcExcel = (slipIds) => async (dispatch) => {
  try {
    dispatch({ type: EXPORT_UPC_EXCEL_REQUEST });

    const response = await api.post(
      "/api/v1/upc/export-excel",
      { slipIds },
      { responseType: "blob" }
    );

    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "upc_export.xlsx";
    a.click();

    window.URL.revokeObjectURL(url);

    dispatch({ type: EXPORT_UPC_EXCEL_SUCCESS });

  } catch (error) {
    dispatch({
      type: EXPORT_UPC_EXCEL_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};


export const createMappingAction = (productData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_MAPPING_REQUEST });

    const { data } = await api.post(
      "/api/v1/mapping/create",
      productData);

    dispatch({
      type: CREATE_MAPPING_SUCCESS,
      payload: data.message
    });

  } catch (error) {
    dispatch({
      type: CREATE_MAPPING_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};


export const updateMappingAction = (productData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_MAPPING_REQUEST });

    const { data } = await api.put("/api/v1/mapping/update", productData);

    dispatch({
      type: UPDATE_MAPPING_SUCCESS,
      payload: data.message
    });

  } catch (error) {
    dispatch({
      type: UPDATE_MAPPING_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};


export const deleteMappingAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_MAPPING_REQUEST });

    const { data } = await api.delete(`/api/v1/mapping/delete?mapping_id=${id}`);

    dispatch({
      type: DELETE_MAPPING_SUCCESS,
      payload: data.message
    });

  } catch (error) {
    dispatch({
      type: DELETE_MAPPING_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

export const allMappingsAction = (queryParams = {}) => async (dispatch) => {
  try {
    dispatch({ type: ALL_MAPPINGS_REQUEST });

    const { data } = await api.get(
      `/api/v1/mapping/my-mappings?${new URLSearchParams(queryParams).toString()}`
    );


    dispatch({
      type: ALL_MAPPINGS_SUCCESS,
      payload: data
    });

  } catch (error) {
    dispatch({
      type: ALL_MAPPINGS_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

